!function(){"use strict";
  var dl=function(o){(window.dataLayer=window.dataLayer||[]).push(o);};
  var productMeta=function(){
    var p=(window.ShopifyAnalytics&&window.ShopifyAnalytics.meta||{}).product||{};
    return{item_id:p.sku||String(p.id||""),item_name:p.title||document.title,
           price:p.price?(p.price/100).toFixed(2):"0.00",
           item_category:p.type||"",item_brand:p.vendor||""};
  };
  var itemsFromCartData=function(d){
    if(!d||!d.items)return[];
    return d.items.slice(0,1).map(function(i){
      return{item_id:i.sku||String(i.id),item_name:i.title,
             price:(i.price/100).toFixed(2),item_category:i.product_type||"",
             item_brand:i.vendor||"",quantity:i.quantity};
    });
  };
  /* ── add_to_cart ──
     2026-09-16: this was a `window.fetch = wrapper` monkey-patch. Verified on the
     live site that a later minified script REPLACES window.fetch outright (the
     property descriptor comes back as `value`, not `accessor`), so the hook was
     silently discarded and add_to_cart was lost on every add. begin_checkout is a
     plain click listener, which is why GA4 showed begin_checkout running ~3x
     add_to_cart on desktop.

     The theme adds via fetch(routes.cart_add_url) in product-form.js and, on
     success, publishes its own pub/sub event: publish('cart-update', {source:
     'product-form', cartData: response}). Subscribing to that is deterministic and
     cannot be clobbered by another script. `subscribe` is global (assets/pubsub.js);
     the event key is PUB_SUB_EVENTS.cartUpdate = 'cart-update' (assets/constants.js). */
  var _lastAtc = 0;
  function emitAddToCart(items, label) {
    var now = Date.now();
    if (now - _lastAtc < 1200) return;   // pubsub + XHR fallback must not double-count
    _lastAtc = now;
    dl({event:"add_to_cart",funnel_step_number:3.5,funnel_step_label:label||"add_to_cart",
        ecommerce:{currency:"USD",items:items}});
  }
  (function bindCartUpdate(tries){
    if (typeof window.subscribe === "function") {
      window.subscribe("cart-update", function(ev){
        if (!ev || ev.source !== "product-form" || !ev.cartData) return;
        var items = itemsFromCartData({items:[ev.cartData]});
        if (!items.length) items = [productMeta()];
        emitAddToCart(items, "add_to_cart");
      });
      return;
    }
    if ((tries||0) < 40) setTimeout(function(){bindCartUpdate((tries||0)+1);}, 150);
  })(0);
  /* ── XHR intercept for older Shopify themes ── */
  var _open=XMLHttpRequest.prototype.open, _send=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){this._url=u;return _open.apply(this,arguments);};
  XMLHttpRequest.prototype.send=function(){
    var xhr=this;
    if(xhr._url&&xhr._url.indexOf("/cart/add")!==-1){
      xhr.addEventListener("load",function(){
        if(xhr.status>=200&&xhr.status<300){
          try{var d=JSON.parse(xhr.responseText);
            emitAddToCart(itemsFromCartData({items:[d]}),"add_to_cart_xhr");
          }catch(e){
            emitAddToCart([productMeta()],"add_to_cart_xhr");
          }
        }
      });
    }
    return _send.apply(this,arguments);
  };

  /* ── begin_checkout: event delegation catches dynamic cart drawer buttons ── */
  var _checkoutFired=false;
  var CHECKOUT_SEL='[name="checkout"],[data-cart-checkout],input[name="checkout"],button[name="checkout"],a[href="/checkout"],a[href*="/checkouts/"],button[data-action="checkout"],.cart__checkout-button,.cart-drawer__checkout';
  function fireBeginCheckout(){
    if(_checkoutFired)return;
    _checkoutFired=true;
    // Fetch live cart data to include items in the event
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      dl({
        event:"begin_checkout",
        funnel_step_number:4.5,
        funnel_step_label:"begin_checkout",
        ecommerce:{
          value:(cart.total_price/100).toFixed(2),
          currency:cart.currency||"USD",
          items:(cart.items||[]).map(function(i){
            return{
              item_id:i.sku||String(i.variant_id),
              item_name:i.title,
              price:(i.price/100).toFixed(2),
              quantity:i.quantity,
              item_category:i.product_type||"",
              item_brand:i.vendor||""
            };
          })
        }
      });
    }).catch(function(){
      dl({event:"begin_checkout",funnel_step_number:4.5,funnel_step_label:"begin_checkout"});
    }).finally(function(){
      // Allow re-fire after 5s so a second checkout attempt can still track
      setTimeout(function(){_checkoutFired=false;},5000);
    });
  }

  // Event delegation on document catches buttons added dynamically (cart drawer, etc.)
  document.addEventListener("click",function(e){
    var t=e.target;
    if(t.closest(CHECKOUT_SEL)){
      fireBeginCheckout();
    }
  },true);

  // MutationObserver: attach click listener to any checkout button injected into DOM
  // (belt-and-suspenders for themes that prevent bubbling)
  if(window.MutationObserver){
    var obs=new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if(node.nodeType!==1)return;
          var els=[];
          try{els=Array.prototype.slice.call(node.querySelectorAll?node.querySelectorAll(CHECKOUT_SEL):[]);}catch(e){}
          if(node.matches&&node.matches(CHECKOUT_SEL))els.push(node);
          els.forEach(function(el){
            el.addEventListener("click",fireBeginCheckout,{once:true});
          });
        });
      });
    });
    obs.observe(document.body||document.documentElement,{childList:true,subtree:true});
  }

  // Also attach at DOMContentLoaded for static checkout buttons on cart page
  document.addEventListener("DOMContentLoaded",function(){
    document.querySelectorAll(CHECKOUT_SEL).forEach(function(el){
      el.addEventListener("click",fireBeginCheckout,{once:true});
    });
  });

  /* ── view_cart: cart drawer open ── */
  document.addEventListener("click",function(e){
    var t=e.target;
    if(t.closest('[data-cart-toggle],[data-open-cart],[aria-label*="cart"],[href="/cart"]')){
      setTimeout(function(){
        dl({event:"view_cart",funnel_step_number:4,funnel_step_label:"view_cart"});
      },300);
    }
  });
}();